import { getAppConfig } from '../config/apps';
import type { AppConfig } from '../config/apps';

const FAVICON_SELECTOR = 'link[rel~="icon"]';

const MIME_BY_EXTENSION: Record<string, string> = {
    svg: 'image/svg+xml',
    png: 'image/png',
    ico: 'image/x-icon',
};

const faviconMimeType = (href: string): string | undefined =>
    MIME_BY_EXTENSION[href.split('.').pop()?.toLowerCase() ?? ''];

/**
 * Stamps the deployed app's document title and favicon onto the neutral
 * index.html shell. Called once from main.tsx at startup — index.html cannot
 * carry per-app branding because the app is chosen by a build-time variable
 * the HTML never sees.
 */
export const applyAppBranding = (
    appConfig: AppConfig = getAppConfig(),
    doc: Document = document,
): void => {
    doc.title = appConfig.htmlTitle;

    let icon = doc.head.querySelector<HTMLLinkElement>(FAVICON_SELECTOR);
    if (!icon) {
        icon = doc.createElement('link');
        icon.rel = 'icon';
        doc.head.appendChild(icon);
    }
    icon.setAttribute('href', appConfig.favicon);

    const mimeType = faviconMimeType(appConfig.favicon);
    if (mimeType) {
        icon.setAttribute('type', mimeType);
    } else {
        icon.removeAttribute('type');
    }
};
